var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 4.81684L3.49832 13.3502C3.24455 13.6038 3.07942 13.9326 3.02748 14.2877L2.56665 17.4327L5.71248 16.9718C6.06762 16.9197 6.39643 16.7542 6.64998 16.5002L15.1833 7.96684M12.0333 4.81684L13.8908 2.9585C14.0146 2.83466 14.1616 2.73642 14.3234 2.66939C14.4852 2.60237 14.6586 2.56787 14.8337 2.56787C15.0089 2.56787 15.1823 2.60237 15.344 2.66939C15.5058 2.73642 15.6528 2.83466 15.7766 2.9585L17.0417 4.2235C17.1655 4.34732 17.2637 4.49432 17.3308 4.6561C17.3978 4.81789 17.4323 4.9913 17.4323 5.16642C17.4323 5.34154 17.3978 5.51495 17.3308 5.67673C17.2637 5.83852 17.1655 5.98552 17.0417 6.10934L15.1833 7.96684M12.0333 4.81684L15.1833 7.96684",
    stroke: "#626262",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename-icon.2fde83cf332b3faa4bf483d0ea1502ff.svg";
export { ForwardRef as ReactComponent };